import Image from 'next/image'
import React from 'react'

export type SupportedCards =
  | 'visa'
  | 'mastercard'
  | 'amex'
  | 'discover'
  | 'diners'
  | 'jcb'
  | 'unionpay'
  | 'default'
  | 'security-code'

type SupportedCardStyles = 'flat' | 'mono' | 'outline' | 'single'

type PaymentIconProps = {
  brand?: SupportedCards
  style?: SupportedCardStyles
  width?: number
  height?: number
}

export const PaymentIcon: React.FC<React.PropsWithChildren<PaymentIconProps>> = ({
  brand = 'default',
  style = 'flat',
  width = 30,
  height = 18,
}) => {
  return (
    <>
      <div className="payment-icon">
        <Image
          src={`/images/payment/${style}/${brand || 'default'}.svg`}
          alt={`${brand} logo`}
          style={{objectFit: 'contain'}}
          width={width}
          height={height}
        />
      </div>

      <style jsx>{`
        .payment-icon {
          position: relative;
          width: ${width}px;
          height: ${height}px;
        }
      `}</style>
    </>
  )
}
